import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './DemoForm.css';
import { FaArrowLeft } from 'react-icons/fa';


const DemoForm = () => {
  const [contactMethod, setContactMethod] = useState('Email');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState('');
  const [otpError, setOtpError] = useState('');
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  
  // Full form state
  const [fullName, setFullName] = useState('');
  const [jobTitle, setJobTitle] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [companyType, setCompanyType] = useState('');
  const [location, setLocation] = useState('');
  const [address, setAddress] = useState('');
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);

  useEffect(() => {
    let timerId;
    if (resendTimer > 0) {
      timerId = setTimeout(() => setResendTimer(resendTimer - 1), 1000);
    }
    return () => clearTimeout(timerId);
  }, [resendTimer]);

  const resetOtpState = () => {
    setOtpSent(false);
    setOtp('');
    setOtpError('');
    setResendTimer(0);
  };

  const handleSendOtp = async () => {
    resetOtpState();
    if (contactMethod === 'Email') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        alert("Please enter a valid email address.");
        return;
      }
      try {
        await axios.post('http://localhost:5000/api/send-otp', { email });
        alert("An OTP has been sent to your email.");
        setOtpSent(true);
        setResendTimer(30);
      } catch (error) {
        alert("Error sending OTP. Please check backend.");
      }
    } else { // Mobile
      if (mobile.length < 10) {
        alert("Please enter a valid 10-digit mobile number.");
        return;
      }
      try {
        await axios.post('http://localhost:5000/api/send-sms-otp', { mobile });
        alert("An OTP has been sent to your mobile number.");
        setOtpSent(true);
        setResendTimer(30);
      } catch (error) {
        alert("Error sending OTP. Please check backend.");
      }
    }
  };

  const handleVerifyOtp = async () => {
    if (otp.length < 4) {
      setOtpError("Please enter a valid OTP.");
      return;
    }
    try {
      const identifier = contactMethod === 'Email' ? email : mobile;
      await axios.post('http://localhost:5000/api/verify-otp', { email: identifier, otp });
      alert("OTP Verified Successfully!");
      setIsOtpVerified(true);
      setOtpError('');
    } catch (error) {
      setOtpError("Invalid OTP. Please try again.");
    }
  };

  const handleSubmitDemoRequest = async (event) => {
    event.preventDefault();
    if (!fullName || !companyName || !companyType || !location || !address || !termsAccepted) {
        alert("Please fill all required fields and accept the terms.");
        return;
    }
    const demoData = {
      contactMethod: contactMethod,
      contactValue: contactMethod === 'Email' ? email : mobile,
      fullName, jobTitle, companyName, companyType, location, address
    };
    try {
      await axios.post('http://localhost:5000/api/submit-demo-request', demoData);
      setIsCompleted(true);
    } catch (error) {
      alert("Error submitting your request. Please try again.");
    }
  };

  if (isCompleted) {
    return (
        <div className="completion-message-container">
            <h2>Thank You!</h2>
            <p>Your demo request has been submitted successfully. Our team will contact you soon.</p>
        </div>
    );
  }

  return (
    <div className="demo-form-layout">
      <div className="demo-info-column">
        <h3>Request a Demo Plan</h3>
        <p>Fill in your details and the account manager will reach out with a scheduled demo of the website packages.</p>
      </div>
      <div className="demo-form-column">
        {!isOtpVerified ? (
          <div className="form-content-wrapper">
            <div className="form-content">
              <h4>Primary Account</h4>
              <div className="contact-method-selector">
                <label><input type="radio" name="contactMethod" value="Email" checked={contactMethod === 'Email'} onChange={() => { setContactMethod('Email'); resetOtpState(); }} /> Email</label>
                {/* <label><input type="radio" name="contactMethod" value="Mobile" checked={contactMethod === 'Mobile'} onChange={() => { setContactMethod('Mobile'); resetOtpState(); }} /> Mobile</label> */}
              </div>
              <div className="form-group">
                <label htmlFor={contactMethod.toLowerCase()}>{contactMethod === 'Email' ? 'E-mail*' : 'Mobile*'}</label>
                <div className="input-with-button">
                  <input type={contactMethod === 'Email' ? 'email' : 'tel'} id={contactMethod.toLowerCase()} value={contactMethod === 'Email' ? email : mobile} onChange={(e) => contactMethod === 'Email' ? setEmail(e.target.value) : setMobile(e.target.value.replace(/[^0-9]/g, ''))} />
                  {!otpSent && <button type="button" className="otp-btn" onClick={handleSendOtp}>Send OTP</button>}
                </div>
              </div>
              {otpSent && (
                <>
                  <div className="form-group otp-group">
                    <label htmlFor="otp">Enter OTP</label>
                    <input type="text" id="otp" value={otp} onChange={(e) => setOtp(e.target.value.replace(/[^0-9]/g, ''))} maxLength="4" />
                    {otpError && <p className="otp-error">{otpError}</p>}
                  </div>
                  <div className="resend-otp-container">
                    {resendTimer > 0 ? (<span>Resend OTP in {resendTimer}s</span>) : (<button type="button" className="resend-btn" onClick={handleSendOtp}>Resend OTP</button>)}
                  </div>
                </>
              )}
            </div>
            <div className="form-navigation">
              <button type="button" className="back-arrow-inline" onClick={() => window.history.back()}><FaArrowLeft /></button>
              {otpSent && <button type="button" className="next-btn" onClick={handleVerifyOtp}>Verify</button>}
            </div>
          </div>
        ) : (
          <form className="form-content-wrapper" onSubmit={handleSubmitDemoRequest}>
            <div className="form-content">
              <h4>Primary Account General Information</h4>
              <div className="form-group"><label>Name *</label><input type="text" value={fullName} onChange={e => setFullName(e.target.value)} required /></div>
              <div className="form-group"><label>Job Title *</label><input type="text" value={jobTitle} onChange={e => setJobTitle(e.target.value)} required /></div>
              <div className="form-group"><label>Company Name *</label><input type="text" value={companyName} onChange={e => setCompanyName(e.target.value)} required /></div>
              <div className="form-group"><label>Company Type *</label>
                <select value={companyType} onChange={e => setCompanyType(e.target.value)} required><option value="">--Please choose an option--</option><option value="Farming">Farming</option><option value="Trading">Trading</option><option value="Processing">Processing</option><option value="Logistics">Logistics</option></select>
              </div>
              <h4>Primary Account Address Information</h4>
              <div className="form-group"><label>Location *</label><input type="text" value={location} onChange={e => setLocation(e.target.value)} required /></div>
              <div className="form-group"><label>Address *</label><textarea value={address} onChange={e => setAddress(e.target.value)} required></textarea></div>
              <div className="terms-checkbox">
                <input type="checkbox" id="terms" checked={termsAccepted} onChange={e => setTermsAccepted(e.target.checked)} />
                <label htmlFor="terms">I have read and accepted the Terms & Conditions and Privacy Policy.</label>
              </div>
            </div>
            <div className="form-navigation">
              <button type="button" className="back-arrow-inline" onClick={() => setIsOtpVerified(false)}><FaArrowLeft /></button>
              <button type="submit" className="proceed-btn">Proceed</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default DemoForm;